module.exports = __webpack_public_path__ + "static/media/lightbulb_1.c738fcdb.png";